import * as React from "react"

export default function OpenAccordionIcon({fill="#1F1646", state}) {
  
  return (
    <svg 
      width="36" 
      height="36" 
      viewBox="0 0 36 36" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M20.25 16H15.75H2.25C1.00736 16 0 17.0074 0 18.25C0 19.4926 1.00736 20.5 2.25 20.5L15.75 20.5H20.25L33.75 20.5C34.9926 20.5 36 19.4926 36 18.25C36 17.0074 34.9926 16 33.75 16H20.25Z" 
        fill={fill}
      />
      <path 
        d="M16 15.75L16 20.25L16 33.75C16 34.9926 17.0074 36 18.25 36C19.4926 36 20.5 34.9926 20.5 33.75L20.5 20.25L20.5 15.75L20.5 2.25C20.5 1.00736 19.4926 -1.52668e-07 18.25 -9.83507e-08C17.0074 -4.40332e-08 16 1.00736 16 2.25L16 15.75Z" 
        fill={fill}
        className={state ? 'open' : null}
      />
    </svg>
  )
}
